import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getRepairersSelector } from '@verzekeringapp-mono/shared/src/state/selectors/companies'
import LocationCard from './LocationCard'

interface IListViewProps {
  setIsFilterModalOpen: (isOpen: boolean) => void
}

const ListView = ({ setIsFilterModalOpen }: IListViewProps) => {
  const locations = useAppSelector(getRepairersSelector)

  return (
    <div className='px-4'>
      <div className='flex flex-row justify-between items-center my-8'>
        <p>{locations.length} resultaten</p>

        <button
          type='button'
          onClick={() => setIsFilterModalOpen(true)}
          className='z-10 rounded-md border border-action-primary-border bg-action-primary-background p-4 text-action-primary-foreground'
        >
          <FontAwesomeIcon
            icon='sliders'
            className='mr-2 text-icon-on-brand'
          />
          Filter
        </button>
      </div>

      {locations.map((location) => (
        <LocationCard
          key={location.name}
          location={location}
        />
      ))}
    </div>
  )
}

export default ListView
